import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = e => {
    e.preventDefault();
    const subject = encodeURIComponent(form.subject || 'Message from AfreXpert Website');
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
    );
    const mailtoLink = `mailto:support@afrexpert.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
    setSent(true);
  };

  return (
    <div className="page contact-page">
      <section className="contact-hero">
        <div className="container">
          <span className="section-label">Get In Touch</span>
          <h1 className="section-title">We'd Love to Hear from You</h1>
          <p className="section-desc">Have a question, partnership inquiry, or feedback? Reach out to us — our team typically responds within 24 hours.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container contact-grid">
          {/* Info Column */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">📧</div>
              <h3>Email Us</h3>
              <a href="mailto:support@afrexpert.com">support@afrexpert.com</a>
              <a href="mailto:partnerships@afrexpert.com">partnerships@afrexpert.com</a>
              <a href="mailto:info@afrexpert.com">info@afrexpert.com</a>
            </div>
            <div className="info-card">
              <div className="info-icon">📱</div>
              <h3>Download the App</h3>
              <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">App Store →</a>
              <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">Google Play →</a>
            </div>
            <div className="info-card">
              <div className="info-icon">🌐</div>
              <h3>Follow Us</h3>
              <div className="social-links">
                <a href="#fb" className="social-chip">Facebook</a>
                <a href="#tw" className="social-chip">Twitter / X</a>
                <a href="#ig" className="social-chip">Instagram</a>
                <a href="#li" className="social-chip">LinkedIn</a>
              </div>
            </div>
            <div className="info-card">
              <div className="info-icon">🕐</div>
              <h3>Support Hours</h3>
              <p>Monday – Friday: 8am – 6pm WAT</p>
              <p>Saturday: 9am – 2pm WAT</p>
            </div>
          </div>

          {/* Form Column */}
          <div className="contact-form-wrapper">
            <h2>Send Us a Message</h2>
            {sent ? (
              <div className="success-msg">
                <span>🎉</span>
                <h3>Your Mail App is Opening!</h3>
                <p>We've pre-filled your message in your default mail app. Just hit send to reach us — we'll get back to you within 24 hours.</p>
                <button onClick={() => { setSent(false); setForm({ name: '', email: '', subject: '', message: '' }); }}>Send Another</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input name="name" value={form.name} onChange={handleChange} placeholder="Your full name" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="your@email.com" required />
                  </div>
                </div>
                <div className="form-group">
                  <label>Subject *</label>
                  <input name="subject" value={form.subject} onChange={handleChange} placeholder="What's this about?" required />
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us more..." rows={6} required />
                </div>
                <button type="submit" className="btn-primary submit-btn">Send Message →</button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
